import { render, staticRenderFns } from "./SelfHostedScript.vue?vue&type=template&id=3db52bb6&scoped=true"
import script from "./SelfHostedScript.vue?vue&type=script&lang=js"
export * from "./SelfHostedScript.vue?vue&type=script&lang=js"
import style0 from "./SelfHostedScript.vue?vue&type=style&index=0&id=3db52bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db52bb6",
  null
  
)

export default component.exports